<div class="date-range-picker-wrapper">
    <!-- Trigger Button -->
    <div class="date-range-input" (click)="togglePicker()">
        <!-- Calendar Icon (left) -->
        <div class="icon-container">
            <img src="assets/icons/calendar.svg" alt="Calendar" width="16" height="16" />
        </div>

        <!-- Date Range Text -->
        <div class="date-range-text">
            {{ getFormattedDateRange() }}
        </div>

        <!-- Dropdown Icon (right) -->
        <div class="icon-container">
            <img src="assets/icons/direction-down01.svg" alt="Arrow Down" width="16" height="16" />
        </div>
    </div>

    <!-- Custom Calendar Dropdown -->
    <div class="custom-date-dropdown" *ngIf="isPickerOpen">
        <div class="calendar-container">
            <!-- Header -->
            <div class="calendar-header">
                <span class="header-title">Calendar</span>
                <button class="btn-save" (click)="applyDateRange()">Save</button>
            </div>

            <!-- Controls -->
            <div class="calendar-controls">
                <!-- Month Dropdown -->
                <div class="custom-dropdown-wrapper" [class.open]="monthDropdownOpen">
                    <div class="custom-dropdown-trigger" (click)="toggleMonthDropdown($event)">
                        <span class="selected-text">{{ months[currentMonth] }}</span>
                        <img src="assets/icons/direction-down01.svg" class="dropdown-arrow" alt="arrow" />
                    </div>
                    <div class="custom-dropdown-menu" *ngIf="monthDropdownOpen">
                        <div class="dropdown-item" *ngFor="let month of months; let i = index"
                            [class.active]="currentMonth === i" (click)="selectMonth(i)">
                            {{ month }}
                        </div>
                    </div>
                </div>

                <!-- Year Dropdown -->
                <div class="custom-dropdown-wrapper" [class.open]="yearDropdownOpen">
                    <div class="custom-dropdown-trigger" (click)="toggleYearDropdown($event)">
                        <span class="selected-text">{{ currentYear }}</span>
                        <img src="assets/icons/direction-down01.svg" class="dropdown-arrow" alt="arrow" />
                    </div>
                    <div class="custom-dropdown-menu" *ngIf="yearDropdownOpen">
                        <div class="dropdown-item" *ngFor="let year of years" [class.active]="currentYear === year"
                            (click)="selectYear(year)">
                            {{ year }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Calendar Grid -->
            <div class="calendar-grid">
                <!-- Week Days -->
                <div class="week-days">
                    <div *ngFor="let day of weekDays" class="week-day">{{ day }}</div>
                </div>

                <!-- Days -->
                <div class="days">
                    <div *ngFor="let dayObj of calendarDays" class="day-cell"
                        [class.other-month]="!dayObj.isCurrentMonth" [class.selected]="isDateSelected(dayObj.date)"
                        [class.in-range]="isDateInRange(dayObj.date)" [class.start-date]="isStartDate(dayObj.date)"
                        [class.end-date]="isEndDate(dayObj.date)" (click)="selectDate(dayObj.date)">
                        {{ dayObj.day }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>